// Capacitor platform detection — safe for both web and native
// In live-reload mode, window.Capacitor may not exist.
// We use a simple localStorage flag: set it once from Xcode build,
// then it persists for live-reload sessions.

export const isNative = () => {
  if (typeof window === 'undefined') return false;
  // Canonical check — @capacitor/core sets window.Capacitor on ALL platforms
  // (including web) as a proxy, but isNativePlatform() correctly returns
  // false on web. Never treat a bare window.Capacitor as native.
  if (window.Capacitor?.isNativePlatform?.()) return true;
  if (window.__SIRAT_NATIVE__) return true;
  // WKWebView-only bridge. Absent in iOS Safari; present in Capacitor iOS shell
  // even if Capacitor global injection is delayed.
  if (window.webkit?.messageHandlers?.capacitor) return true;
  return false;
};

export const isIOS = () =>
  isNative() && (/iPhone|iPad|iPod/.test(navigator.userAgent) || window.Capacitor?.getPlatform?.() === 'ios');

export const isAndroid = () =>
  isNative() && (/Android/.test(navigator.userAgent) || window.Capacitor?.getPlatform?.() === 'android');

export const isWeb = () => !isNative();
